import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const defaultProps = {
  min: 0,
  max: 10,
  value: 0,
  label: '',
  class: '',
  areaLabelIncrease: Drupal.t('Increase'),
  areaLabelDecrease: Drupal.t('Decrease'),
};

const NumberInput = (properties) => {
  const props = {
    ...defaultProps,
    ...properties,
  };
  const increaseValue = () => {
    props.value < props.max ? props.setter(props.value + 1) : null;
  };
  const decreaseValue = () => {
    props.value > props.min ? props.setter(props.value - 1) : null;
  };

  return (
    <div className={`number-input ${props.class}`}>
      <div className="number-input__label">
        <label htmlFor={props.id}>{props.label}</label>
      </div>
      <div className="number-input__button number-input__button--decrease">
        <button
          type="button"
          aria-label={props.areaLabelDecrease}
          onClick={decreaseValue}
          disabled={props.disabled}
        >
          <span className="number-input__button__control-icon">–</span>
        </button>
      </div>
      <div className="number-input__value form-item">
        <input
          type="number"
          value={props.value}
          onChange={(event) => props.setter(parseInt(event.target.value))}
          id={props.id}
          name={props.id}
          min={props.min}
          max={props.max}
          readOnly={true}
          disabled={props.disabled}
        />
      </div>
      <div className="number-input__button number-input__button--increase">
        <button
          type="button"
          aria-label={props.areaLabelIncrease}
          onClick={increaseValue}
          disabled={props.disabled}
        >
          <span className="number-input__button__control-icon">+</span>
        </button>
      </div>
    </div>
  );
};

NumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  setter: PropTypes.func.isRequired,
  areaLabelIncrease: PropTypes.string,
  areaLabelDecrease: PropTypes.string,
  class: PropTypes.string,
  disabled: PropTypes.bool,
};

export default NumberInput;
